const initialStatePosition = {
    position: [],
    update_position: true,
};

export default initialStatePosition;